var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPositionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.25023H13.56L16.59 3.47023C16.85 3.15023 16.8 2.67023 16.47 2.42023C16.15 2.16023 15.68 2.21023 15.42 2.54023L12.01 6.81023L8.60002 2.54023C8.34002 2.22023 7.87002 2.17023 7.55002 2.42023C7.23002 2.68023 7.17002 3.15023 7.43002 3.47023L10.46 7.25023H8.02002C7.06002 7.25023 6.27002 8.04023 6.27002 9.00023V20.0002C6.27002 20.9602 7.06002 21.7502 8.02002 21.7502H16.02C16.98 21.7502 17.77 20.9602 17.77 20.0002V9.00023C17.77 8.04023 16.98 7.25023 16.02 7.25023H16ZM16.25 20.0002C16.25 20.1402 16.14 20.2502 16 20.2502H8.00002C7.86002 20.2502 7.75002 20.1402 7.75002 20.0002V9.00023C7.75002 8.86023 7.86002 8.75023 8.00002 8.75023H16C16.14 8.75023 16.25 8.86023 16.25 9.00023V20.0002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13C14.75 11.48 13.52 10.25 12 10.25C10.48 10.25 9.25 11.48 9.25 13C9.25 13.79 9.59 14.5 10.12 15C9.58 15.5 9.25 16.21 9.25 17V18C9.25 18.41 9.59 18.75 10 18.75C10.41 18.75 10.75 18.41 10.75 18V17C10.75 16.31 11.31 15.75 12 15.75C12.69 15.75 13.25 16.31 13.25 17V18C13.25 18.41 13.59 18.75 14 18.75C14.41 18.75 14.75 18.41 14.75 18V17C14.75 16.21 14.41 15.5 13.88 15C14.42 14.5 14.75 13.79 14.75 13ZM10.75 13C10.75 12.31 11.31 11.75 12 11.75C12.69 11.75 13.25 12.31 13.25 13C13.25 13.69 12.69 14.25 12 14.25C11.31 14.25 10.75 13.69 10.75 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionIcon);
export default __webpack_public_path__ + "static/media/position_icon.affdeb4ddbb189fe735733582c22c83f.svg";
export { ForwardRef as ReactComponent };